import {jwtDecode} from "jwt-decode";

export function isAuthenticated() {
    const token = localStorage.getItem("accessToken");
    if (token) {
        try {
            return isValidToken(token);
        } catch (err) {
            console.error("Token không hợp lệ:", err.message);
            return false;
        }
    }
}

function isValidToken(token) {
    try {
        const decoded = jwtDecode(token);

        const expectedIssuer = "https://securetoken.google.com/vuejs-cb0f7";

        if (Date.now() > (decoded.exp * 1000)) {
            return false;
        }

        return decoded.iss === expectedIssuer;


    } catch (err) {
        return false;
    }
}
